var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedProformaStepper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5763 7.24935L10.0013 8.82435L8.4263 7.24935C8.1013 6.92435 7.5763 6.92435 7.2513 7.24935C6.9263 7.57435 6.9263 8.09935 7.2513 8.42435L8.8263 9.99935L7.2513 11.5743C6.9263 11.8994 6.9263 12.4243 7.2513 12.7493C7.5763 13.0743 8.1013 13.0743 8.4263 12.7493L10.0013 11.1743L11.5763 12.7493C11.9013 13.0743 12.4263 13.0743 12.7513 12.7493C13.0763 12.4243 13.0763 11.8994 12.7513 11.5743L11.1763 9.99935L12.7513 8.42435C13.0763 8.09935 13.0763 7.57435 12.7513 7.24935C12.4263 6.93268 11.893 6.93268 11.5763 7.24935ZM10.0013 1.66602C5.39297 1.66602 1.66797 5.39102 1.66797 9.99935C1.66797 14.6077 5.39297 18.3327 10.0013 18.3327C14.6096 18.3327 18.3346 14.6077 18.3346 9.99935C18.3346 5.39102 14.6096 1.66602 10.0013 1.66602ZM10.0013 16.666C6.3263 16.666 3.33464 13.6743 3.33464 9.99935C3.33464 6.32435 6.3263 3.33268 10.0013 3.33268C13.6763 3.33268 16.668 6.32435 16.668 9.99935C16.668 13.6743 13.6763 16.666 10.0013 16.666Z",
    fill: "#FF4842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedProformaStepper);
export default __webpack_public_path__ + "static/media/FailedProformaStepper.2e925e993b7debafb595d0eaae4ce3dd.svg";
export { ForwardRef as ReactComponent };